import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

export const FAQSC = styled.div`
    max-width: 720px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 10px;
    padding-top: 64px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
     ${NoTextSelectionStyles}

    .faq-title {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 32px;
        letter-spacing: 2px;
    }

    .faq-item {
        background: #ffffff;
        border-radius: 10px;
        width: 1000px;
        border: 1px solid #e6e6e6;
        overflow: hidden;
        transition: box-shadow 0.2s ease;
    }

    .faq-item.open {
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
    }

    .faq-question {
        width: 100%;
        padding: 16px 18px;
        background: none;
        border: none;
        outline: none;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;

        font-size: 18px;
        font-weight: 500;
        color: #1f2937;
        text-align: left;
    }

    /* Icon */
    .faq-icon {
        font-size: 22px;
        line-height: 1;
        color: #7c3aed;
        font-weight: 400;
    }

    /* Answer */
    .faq-answer {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease, opacity 0.3s ease;
        opacity: 0;
    }

    .faq-item.open .faq-answer {
        max-height: 200px;
        opacity: 1;
    }

    .faq-answer p {
        padding: 0 18px 16px;
        margin: 0;
        font-size: 18px;
        line-height: 1.6;
        color: #6b7280;
    }

    @media (max-width: 768px) {
        max-width: unset;
        margin: unset;
        width: 90%;
        gap: 6px;
        padding-top: 24px;
        margin-bottom: -28px;

        .faq-title {
            font-size: 16px;
            margin-bottom: 16px;
            letter-spacing: 1px;
        }

        .faq-item {
            border-radius: 10px;
            width: 100%;
        }

        .faq-item.open {
            padding-bottom: 12px
        }

        .faq-question {
            width: 100%;
            padding: 12px 16px;
            font-size: 14px;
            -webkit-tap-highlight-color: transparent;
        }

        .faq-icon {
            font-size: 14px;
            line-height: 1;
            color: #24025fff;
            font-weight: 400;
        }

        .faq-answer {
            opacity: 0;
        }

        .faq-item.open .faq-answer {
            max-height: 300px;
        }

        .faq-answer p {
            padding: 2px 16px;
            font-size: 14px;
            line-height: 1.6;
            color: #6b7280;
        }
    }
`;